const Category = {
  DOWNLOAD: "download",
  SHOP: "shop",
  VIDEOS: "videos"
};

const DocType = {
  BLOG: "blog"
};

export { Category, DocType };
